module.exports = __webpack_public_path__ + "static/media/done-badge-large.f3c7c9db.svg";